import http, { url } from '../../http'

const API_URL = "corrective_actions"

class accionesCorrectivasPreventivasAPI {

  async save(corrective_actions) {
    const response = await http(`${API_URL}/save`, 'POST', corrective_actions)
    return response
  }
 
  async getAll(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  } 

  async getList() {
    const response = await http(`${API_URL}/acctionList`)
    return response
  } 

  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  } 


  async getAllIdentificacion(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getFiles(id) {
    const response = await http(`identification_evaluation_files/${id}`, 'POST')
    return response
  } 



  async update(id, revision) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revision)
    return response
  }
  async deleteAccion(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  
}

export default new accionesCorrectivasPreventivasAPI()